function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));

  if(summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', (event) => {
    event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
  });

  if (summary.closest('header-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function() {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function(event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch(e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = ['ARROWUP', 'ARROWDOWN', 'ARROWLEFT', 'ARROWRIGHT', 'TAB', 'ENTER', 'SPACE', 'ESCAPE', 'HOME', 'END', 'PAGEUP', 'PAGEDOWN']
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if(navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener('focus', () => {
    if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

    if (mouseClick) return;

    currentFocusedElement = document.activeElement;
    currentFocusedElement.classList.add('focused');

  }, true);
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true })

    this.querySelectorAll('button').forEach(
      (button) => button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
  };
}

/*
 * Shopify Common JS
 *
 */
if ((typeof window.Shopify) == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function(fn, scope) {
  return function() {
    return fn.apply(scope, arguments);
  }
};

Shopify.setSelectorByValue = function(selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function(target, eventName, callback) {
  target.addEventListener ? target.addEventListener(eventName, callback, false) : target.attachEvent('on'+eventName, callback);
};

Shopify.postLink = function(path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for(var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function(country_domid, province_domid, options) {
  this.countryEl         = document.getElementById(country_domid);
  this.provinceEl        = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler,this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function() {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function() {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function(e) {
    var opt       = this.countryEl.options[this.countryEl.selectedIndex];
    var raw       = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function(selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function(selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  }
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');
    this.select_size = document.querySelector(".size_map .select") ? document.querySelector(".size_map .select") : false;
    this.error = document.querySelector(".size_error") ? document.querySelector(".size_error") : false;
    this.in_pdp = this.classList.contains("product_information");
    this.close_pdp_sidebar = this.querySelector('.sidebar__heading .facets__close');

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    if(this.close_pdp_sidebar) this.close_pdp_sidebar.addEventListener('click', this.closeMenuDrawer.bind(this));
    this.querySelectorAll('summary').forEach(summary => summary.addEventListener('click', this.onSummaryClick.bind(this)));
    this.querySelectorAll('button.menu-drawer__close-button').forEach(button => button.addEventListener('click', this.onCloseButtonClick.bind(this)));
  }

  onKeyUp(event) {
    if(event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if(!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary')) : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest('.has-submenu');

    const isOpen = detailsElement.hasAttribute('open');
    const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

    function addTrapFocus() {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
      summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
    }
    if(!detailsElement.classList.contains("disable")){
      if (detailsElement === this.mainDetailsToggle) {
        if(isOpen) event.preventDefault();
        isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);

        if (window.matchMedia('(max-width: 990px)')) {
          document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
        }
      } else {
        setTimeout(() => {
          detailsElement.classList.add('menu-opening');
          summaryElement.setAttribute('aria-expanded', true);
          parentMenuElement && parentMenuElement.classList.add('submenu-open');
          !reducedMotion || reducedMotion.matches ? addTrapFocus() : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
        }, 100);
      }
    }
    else{
      setTimeout(() => {
        detailsElement.removeAttribute('open');
      }, 100);
      if(!this.error.classList.contains("visible")){
        this.error.classList.add("visible");
      }
      if(!this.select_size.classList.contains("error")){
        this.select_size.classList.add("error");
      }
    }
  }

  openMenuDrawer(summaryElement) {
    if(!summaryElement.parentNode.classList.contains('disable')){
      setTimeout(() => {
          this.mainDetailsToggle.classList.add('menu-opening');
      });
      summaryElement.setAttribute('aria-expanded', true);
      trapFocus(this.mainDetailsToggle, summaryElement);
      document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
    }
    //customization for sidebar in pdp
    if(this.in_pdp){
      if(!document.querySelector(".product__info-container").classList.contains("high-index")){
        document.querySelector(".product__info-container").classList.add("high-index");
      }
      if(!document.querySelector("body").classList.contains("block-scroll")){
        document.querySelector("body").classList.add("block-scroll");
      }
    }
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove('menu-opening');
    this.mainDetailsToggle.querySelectorAll('details').forEach(details => {
      details.removeAttribute('open');
      details.classList.remove('menu-opening');
    });
    this.mainDetailsToggle.querySelectorAll('.submenu-open').forEach(submenu => {
      submenu.classList.remove('submenu-open');
    });
    //customization for sidebar in pdp
    if(this.in_pdp){
      if(document.querySelector(".product__info-container").classList.contains("high-index")){
        setTimeout(()=>{
          document.querySelector(".product__info-container").classList.remove("high-index");
        }, 500);
      }
      if(document.querySelector("body").classList.contains("block-scroll")){
        document.querySelector("body").classList.remove("block-scroll");
      }
    }
    document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);
  }

  onFocusOut(event) {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement)) this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
    //customization for sidebar in pdp
    if(this.in_pdp){
      document.querySelector(".product__info-container").classList.toggle("high-index");
      document.querySelector("body").classList.toggle("block-scroll");
    }
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest('.submenu-open');
    parentMenuElement && parentMenuElement.classList.remove('submenu-open');
    this.mainDetailsToggle.classList.remove('opened')
    detailsElement.classList.remove('menu-opening');
    detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
    removeTrapFocus(detailsElement.querySelector('summary'));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    }

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);


class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.getElementById('shopify-section-header');
    this.borderOffset = this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
    document.documentElement.style.setProperty('--header-bottom-position', `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`);
    this.header.classList.add('menu-open');

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });

    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus) {
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove('menu-open');
  }
}

customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      'click',
      this.hide.bind(this, false)
    );
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    document.body.dispatchEvent(new CustomEvent('modalClosed'));
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    // button.addEventListener('click', () => {
    //   const modal = document.querySelector(this.getAttribute('data-modal'));
    //   if (modal) modal.show(button);
    // });
    this.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
      if (focus) deferredElement.focus();
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector('.slider-counter--current');
    this.pageTotalElement = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver(entries => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update.bind(this));
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter(element => element.clientWidth > 0);
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.floor((this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) / this.sliderItemOffset);
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    const previousPage = this.currentPage;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(new CustomEvent('slideChanged', { detail: {
        currentPage: this.currentPage,
        currentElement: this.sliderItemsToShow[this.currentPage - 1]
      }}));
    }

    if (this.enableSliderLooping) return;

    if (this.isSlideVisible(this.sliderItemsToShow[0]) && this.slider.scrollLeft === 0) {
      this.prevButton.setAttribute('disabled', 'disabled');
    } else {
      this.prevButton.removeAttribute('disabled');
    }

    if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
      this.nextButton.setAttribute('disabled', 'disabled');
    } else {
      this.nextButton.removeAttribute('disabled');
    }
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
    return (element.offsetLeft + element.clientWidth) <= lastVisibleSlide && element.offsetLeft >= this.slider.scrollLeft;
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition = event.currentTarget.name === 'next' ? this.slider.scrollLeft + (step * this.sliderItemOffset) : this.slider.scrollLeft - (step * this.sliderItemOffset);
    this.slider.scrollTo({
      left: this.slideScrollPosition
    });
  }
}

customElements.define('slider-component', SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector('.slider-buttons');
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector('.slideshow__slide');
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.sliderControlLinksArray = Array.from(this.sliderControlWrapper.querySelectorAll('.slider-counter__link'));
    this.sliderControlLinksArray.forEach(link => link.addEventListener('click', this.linkToSlide.bind(this)));
    this.slider.addEventListener('scroll', this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
  }

  setAutoPlay() {
    this.sliderAutoplayButton = this.querySelector('.slideshow__autoplay');
    this.autoplaySpeed = this.slider.dataset.speed * 1000;

    this.sliderAutoplayButton.addEventListener('click', this.autoPlayToggle.bind(this));
    this.addEventListener('mouseover', this.focusInHandling.bind(this));
    this.addEventListener('mouseleave', this.focusOutHandling.bind(this));
    this.addEventListener('focusin', this.focusInHandling.bind(this));
    this.addEventListener('focusout', this.focusOutHandling.bind(this));

    this.play();
    this.autoplayButtonIsSetToPlay = true;
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) return;

    if (isFirstSlide && event.currentTarget.name === 'previous') {
      this.slideScrollPosition = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === 'next') {
      this.slideScrollPosition = 0;
    }
    this.slider.scrollTo({
      left: this.slideScrollPosition
    });
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll('.slider-counter__link');
    this.prevButton.removeAttribute('disabled');

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach(link => {
      link.classList.remove('slider-counter__link--active');
      link.removeAttribute('aria-current');
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add('slider-counter__link--active');
    this.sliderControlButtons[this.currentPage - 1].setAttribute('aria-current', true);
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    const focusedOnAutoplayButton = event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
    if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
    this.play();
  }

  focusInHandling(event) {
    const focusedOnAutoplayButton = event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
    if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
      this.play();
    } else if (this.autoplayButtonIsSetToPlay) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute('aria-live', 'off');
    clearInterval(this.autoplay);
    this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed);
  }

  pause() {
    this.slider.setAttribute('aria-live', 'polite');
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.playSlideshow);
    } else {
      this.sliderAutoplayButton.classList.remove('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.pauseSlideshow);
    }
  }

  autoRotateSlides() {
    const slideScrollPosition = this.currentPage === this.sliderItems.length ? 0 : this.slider.scrollLeft + this.slider.querySelector('.slideshow__slide').clientWidth;
    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }

  setSlideVisibility() {
    this.sliderItemsToShow.forEach((item, index) => {
      const linkElements = item.querySelectorAll('a');
      if (index === this.currentPage - 1) {
        if (linkElements.length) linkElements.forEach(button => {
          button.removeAttribute('tabindex');
        });
        item.setAttribute('aria-hidden', 'false');
        item.removeAttribute('tabindex');
      } else {
        if (linkElements.length) linkElements.forEach(button => {
          button.setAttribute('tabindex', '-1');
        });
        item.setAttribute('aria-hidden', 'true');
        item.setAttribute('tabindex', '-1');
      }
    });
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * (this.sliderControlLinksArray.indexOf(event.currentTarget) + 1 - this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }
}

customElements.define('slideshow-component', SlideshowComponent);

class sizeMapping extends HTMLElement{
  constructor(){
    super();
    this.size_mapping = this.querySelector("#size_mapping");
    this.size_select = this.querySelector(".select select");
    //this.country_select = this.querySelector(".select_country select");
    this.prd_type = this.dataset.type;
    this.gender = this.dataset.gender;
    this.brand = this.dataset.brand;
    this.master_sku = this.dataset.sku;
    this.id = this.dataset.id;
    this.element = null;
    //this.buildCountrySelect();
    //this.checkCountrySelect();
    // this.addEventListener("change", (e)=> {
    //   if(e.target == this.country_select){
    //     this.onCountryChange();
    //   }
    // })
  }

  getSizeMapping(){
    return this.size_mapping;
  }

  checkCountrySelect(){
    if(this.country_select && this.country_select.options.length == 0){
      this.country_select.closest(".select_country").classList.add("hide");
    }
  }

  buildOptionsCountry(i){
    let option = null;
    option = document.createElement("option");
    option.text = i;
    option.value = i;
    this.country_select.add(option);
  }

  buildCountrySelect(){
    if(this.size_mapping){
      let obj = this.getObj();
      // console.log(obj);
      obj.map(element => {
        if(element.id == this.id){
          for(let i in element.size[0]){
            this.buildOptionsCountry(i);
          }
          this.element =  element;
        }
      });
    }
  }

  getObj(){
    let json_map = this.size_mapping.innerHTML;
    let obj = JSON.parse(json_map);
    return obj;
  }

  onCountryChange(){
    let size_options = this.size_select.querySelectorAll("option");
    let i = 1;
    if(this.element != null){
      for(let value of this.element.size){
        // console.log(value[this.country_select.selectedOptions[0].value]);
        size_options[i].text = value[this.country_select.selectedOptions[0].value];
        i++;
      }
    }
  }
}

customElements.define("size-map", sizeMapping);

class tableSize extends HTMLElement{
  constructor(){
    super();
    this.size_mapping = this.dataset.sizemap;
    this.prd_type = this.dataset.type;
    this.gender = this.dataset.gender;
    this.brand = this.dataset.brand;
    this.master_sku = this.dataset.sku;
    this.id = this.dataset.id;
    this.obj = this.getObj();
    this.table = this.querySelector(".size-guide_table");
    this.header = this.querySelector(".size-guide_table .heading_row");
    this.buildTable();
  }

  getObj(){
    let json_map = this.size_mapping;
    let obj = JSON.parse(json_map);
    return obj;
  }

  buildTable(){
    this.obj.map(element => {
      // if(element.item_code != null){
      //   if(element.item_code == this.item_code){
      //     //countries
      //     this.buildHeader(element);
      //     //taglie di riferimento (es. XS se eur)
      //     this.buildMainSizes(element);
      //   }
      // }
      // else{
      //   if(element.brand != null && element.gender != null && element.macrocategory != null){
      //     if(element.brand == this.brand && element.gender == this.gender && element.macrocategory == this.prd_type){
      //       //countries
      //       this.buildHeader(element);
      //       //taglie di riferimento (es. XS se eur)
      //       this.buildMainSizes(element);
      //     }
      //   }
      //   else{
      //     if(element.macrocategory != null && element.gender != null){
      //       if(element.macrocategory == this.prd_type && element.gender == this.gender){
      //         //countries
      //         this.buildHeader(element);
      //         //taglie di riferimento (es. XS se eur)
      //         this.buildMainSizes(element);
      //       }
      //     }
      //     else{
      //       if(element.macrocategory != null){
      //         if(element.macrocategory == this.prd_type){
      //           //countries
      //           this.buildHeader(element);
      //           //taglie di riferimento (es. XS se eur)
      //           this.buildMainSizes(element);
      //         }
      //       }
      //     }
      //   }
      // }
      if(element.id == this.id){
        //countries
        this.buildHeader(element);
        //taglie di riferimento (es. XS se eur)
        this.buildMainSizes(element);
      }
    });
  }

  buildHeader(obj){
    let header_data = this.getHeader(obj.size);
    let country = null;
    for(let data of header_data){
      country = document.createElement("th");
      country.innerHTML = data;
      this.header.appendChild(country);
    }
  }

  getHeader(obj){
    let array = [];
    for(let value of obj){
      //prendo le size parsate le ciclo ed escludo quelle che non valorizzate
      Object.entries(value).forEach(entry=>{
        if(!entry.includes('')){
          const [key, value] = entry;
          array.push(key);
        }
      })
    }
    //elimina duplicati
    return array.filter((item,index) => array.indexOf(item) === index);
  }

  buildMainSizes(obj){
    let row = null;
    let data = null;
    for(let value of obj.size){
      // console.log(value);
      row = document.createElement("tr");
      this.table.appendChild(row);
      Object.entries(value).forEach(entry=>{
        const [key, value] = entry;
        data = document.createElement("td");
        data.innerHTML = value;
        row.appendChild(data);
      })
    }
  }
}

customElements.define("table-size", tableSize);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.shopsContainer = document.querySelector('.product__shops-availability') ? document.querySelector('.product__shops-availability') : false;
    this.find_in_store = this.shopsContainer ? this.shopsContainer.querySelector("details") : false;
    this.low_stock = document.querySelector(".low_stock") ? document.querySelector(".low_stock") : false
    this.checkVariantUrl();
    this.oneUnit = this.dataset.one == 'true';
    this.handle = this.dataset.handle;
    this.checkCart();
    //se il blocco dell'add to cart al change della country va disabilitato passare event a onVariantChange e disabilita funzionamento al target country
    this.addEventListener('change', ()=>{
      this.checkCart();
    });
  }

  //caso tag one unit non deve partire il comportamento del check delle varianti che riabilitano il bottone
  checkCart(){
    if(this.oneUnit){
      fetch('/cart.js')
      .then((response) => response.json())
      .then((data) => {
        for(const item of data.items){
          if(item.handle == this.handle){
            this.onVariantChangeWithoutToggle();
            return;
          }
        }
      });
    }
    this.onVariantChange();
  }

  //prd one per customer non riabilita submit btn
  onVariantChangeWithoutToggle(){
    this.updateOptions();
    this.updateMasterId();
    if (this.shopsContainer) {
      this.getShopsAvailability();
    }
    if(this.currentVariant){
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.updateShareUrl();
    }
  }

  onVariantChange(handleError) {
    this.updateOptions();
    this.updateMasterId();
    if(this.low_stock) this.checkStock();
    if (this.shopsContainer) {
      this.getShopsAvailability();
    }
    this.toggleAddButton(true, '', false);
    this.updatePickupAvailability();
    //this.removeErrorMessage();

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      //this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
    }
  }

  //Se arrivo da un link alla pdp in cui è contenuta la variante, cambio la select
  checkVariantUrl(){
    let url = window.location.href;
    let obj = new URL(url);
    let variantId = 0;
    let variants = this.getVariantData();
    let select = this.querySelector(".select__select");

    if(obj.searchParams.has("variant")){
      variantId = obj.searchParams.get("variant");
      const variantUrl = variants.filter((variant) => variant.id == variantId );
      select.value = variantUrl[0].title;
    }

  }

  checkStock(){
    this.querySelectorAll(".select select option").forEach((option)=>{
      if(option.value == this.querySelector(".select select").value){
        // console.log(option.dataset.quantity);
        if(parseInt(option.dataset.quantity) < parseInt(this.dataset.lowstock) && parseInt(option.dataset.quantity) > 0){
          if(!this.low_stock.classList.contains("visible"))
            this.low_stock.classList.add("visible")
        }
        else{
          if(this.low_stock.classList.contains("visible"))
            this.low_stock.classList.remove("visible")
        }
      }
    })
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options.map((option, index) => {
        return this.options[index] === option;
      }).includes(false);
    });
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    const mediaGalleries = document.querySelectorAll(`[id^="MediaGallery-${this.dataset.section}"]`);
    mediaGalleries.forEach(mediaGallery => mediaGallery.setActiveMedia(`${this.dataset.section}-${this.currentVariant.featured_media.id}`, true));

    const modalContent = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`);
    if (!modalContent) return;
    const newMediaModal = modalContent.querySelector( `[data-media-id="${this.currentVariant.featured_media.id}"]`);
    modalContent.prepend(newMediaModal);
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState({ }, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateShareUrl() {
    const shareButton = document.getElementById(`Share-${this.dataset.section}`);
    if (!shareButton || !shareButton.updateUrl) return;
    shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`);
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html')
        const destination = document.getElementById(`price-${this.dataset.section}`);
        const source = html.getElementById(`price-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);
        if (source && destination) destination.innerHTML = source.innerHTML;

        const price = document.getElementById(`price-${this.dataset.section}`);

        if (price) price.classList.remove('visibility-hidden');
        this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut);
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const iconBag = productForm.querySelector('[name="add"] > span > svg');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    if (!addButton) return;

    const variantData = this.getVariantData();

    if (variantData.length <= 1) {
      return;
    }
    if(addButton.classList.contains("error")){
      addButton.classList.remove("error");
      document.querySelector(".product-form__error-message-wrapper").hidden = true;
    }
    if (disable) {
      addButton.setAttribute('disabled', 'disabled');
      if (text){
        addButtonText.textContent = text;
        if(iconBag != null)
          addButtonText.prepend(iconBag);
      }
    } else {
      addButton.removeAttribute('disabled');
      addButtonText.textContent = window.variantStrings.addToCart;
      if(iconBag != null)
        addButtonText.prepend(iconBag);
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.section}`);
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add('visibility-hidden');
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }

  getShopsAvailability() {
    this.shopsContainer.querySelector('details').setAttribute('disabled', true);
    if (this.currentVariant) {
      this.currentVariantSelected = this.getVariantMetafield().find((variant) => {
          return this.currentVariant.id === variant.id;
      });

      this.renderShopsAvailabilityInfo(false);
    }
    else{
      this.renderShopsAvailabilityInfo(true);
    }
  }

  renderShopsAvailabilityInfo(fallback) {
    const self = this;
    this.shopsAvailable = 0;
    if(!fallback){
      if(this.find_in_store.classList.contains("disable")){
        this.find_in_store.classList.remove("disable");
      }
      if(this.querySelector(".select").classList.contains("error")){
        this.querySelector(".select").classList.remove("error");
      }
      if(this.querySelector(".size_error")?.classList.contains("visible")){
        this.querySelector(".size_error").classList.remove("visible");
      }
      const filtered_shops = this.excludeShops(self.currentVariantSelected.shops);
      this.shopsContainer.querySelectorAll('.list-shops li').forEach(function (item, index) {
        if (!filtered_shops.includes(item.dataset.id)) {
            item.classList.add('hidden');
            // item.querySelector('span').innerText = window.variantStrings.unavailable
        } else {
            self.shopsAvailable++;
            item.classList.remove('hidden');
            item.querySelector('span').innerText = window.variantStrings.available;
        }
      });
      if(self.shopsAvailable == 0) {
          const shopsList = this.shopsContainer.querySelector('.list-shops');
          const listItem = document.createElement('li');
          listItem.innerHTML = window.variantStrings.shops_unavailable;
          shopsList.appendChild(listItem);
      }
    }
    else{
      // this.shopsContainer.querySelectorAll('.list-shops li').forEach(function (item, index) {
      //   item.classList.add('hidden');
      // })
      // const shopsList = this.shopsContainer.querySelector('.list-shops');
      // const listItem = document.createElement('li');
      // listItem.innerHTML = window.variantStrings.shops_unavailable;
      // shopsList.appendChild(listItem);
      if(!this.find_in_store.classList.contains("disable")){
        this.find_in_store.classList.add("disable");
      }
    }
  }

  //alcuni store non appaiono se ce ne sono altri
  excludeShops(shops){
    shops = shops.split(",");
    if(shops.includes("DOM") && shops.includes("DOMM")){
      shops.splice(shops.indexOf("DOMM"), 1);
    }
    if(shops.includes("GAL") && shops.includes("GALM")){
      shops.splice(shops.indexOf("GALM"), 1);
    }
    if(shops.includes("LEV") && shops.includes("LEVM")){
      shops.splice(shops.indexOf("LEVM"), 1);
    }
    if(shops.includes("REP") && shops.includes("REPM")){
      shops.splice(shops.indexOf("REPM"), 1);
    }
    return shops;
  }

  getVariantMetafield() {
    this.variantMetafield = this.variantMetafield || JSON.parse(this.shopsContainer.querySelector('[type="application/json"]').textContent);
    return this.variantMetafield;
  }
}

customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
    });
  }
}

customElements.define('variant-radios', VariantRadios);

/** Back in stock
* custom notify-popup
* https://help.backinstock.org/article/2303-javascript-api
**/
class notifyMePopup extends ModalDialog {
  constructor() {
      super();
      this.button          = this.querySelector('#notify_me');
      this.privacyField    = this.querySelector('.notify-me__privacy');
      this.privacy         = this.querySelector('#notify__privacy');
      this.email           = this.querySelector('#notify_email');
      this.select          = this.querySelector('#notify_variant');
      this.dialogContainer = this.querySelector('.dialog__container');
      this.dialog_notify   = this.querySelector(".dialog__notification");

      this.addEvents();
  }

  addEvents() {
    const self = this;
    this.button.addEventListener('click', function(event) {
      event.preventDefault();

      self.classList.remove('notification');

      if(self.privacy.checked) {
          self.privacyField.classList.remove('field--error');

          const email       = self.email.value,
                productId   = self.select.getAttribute('data-product'),
                variantId   = self.select.value;

          const email_regex = /^(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|'(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*')@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9]))\.){3}(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9])|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])$/i;

          if(email.match(email_regex)){
            self.email.closest(".field").classList.remove('field--error');
            // Back in stock API
            BIS.create(email, variantId, productId)
              .then(self.notificationCallback())

            self.classList.add('notification');
            setTimeout(() => {
              self.hide();
              self.dialog_notify.classList.remove("show");
              self.email.value = "";
            }, 3000);
          }
          else{
            self.email.closest(".field").classList.add('field--error');
          }

      } else {
        self.privacyField.classList.add('field--error');
      }
    })
    this.email.addEventListener("click", ()=>{
      if(this.email.closest(".field").classList.contains("field--error")){
        this.email.closest(".field").classList.remove("field--error")
      }
    });
    this.privacyField.addEventListener("click", ()=>{
      if(this.privacyField.classList.contains("field--error")){
        this.privacyField.classList.remove("field--error")
      }
    });
    window.addEventListener('dialog-open', ()=> {
      self.setAttribute("open", "");
    })
  }

  notificationCallback(){
    this.dialog_notify.classList.add("show");
  }
}
customElements.define('notifyme-popup', notifyMePopup);

class WishlistButton extends HTMLElement{
  constructor(){
    super();
    this.s_wishlist = this.querySelector(".smartwishlist");
  }

  connectedCallback(){
    //this.observer();
    this.addEventListener('click', (e)=>{
      this.s_wishlist.click();
      //this.writeLabel(this.s_wishlist.ariaLabel);
    })
  }

  writeLabel(label){
    this.querySelector('.button span').innerText = label;
  }

  observer(){
    // Select the node that will be observed for mutations
    const targetNode = this.s_wishlist;
    // Options for the observer (which mutations to observe)
    const config = { attributes: false, childList: true, subtree: false };

    // Callback function to execute when mutations are observed
    const callback = (mutationList, observer) => {
      for (const mutation of mutationList) {
        if (mutation.type === 'childList') {
          console.log(targetNode.ariaLabel);
          this.writeLabel(targetNode.ariaLabel);
          observer.disconnect();
        }
      }
    };

    // Create an observer instance linked to the callback function
    const observer = new MutationObserver(callback);

    // Start observing the target node for configured mutations
    observer.observe(targetNode, config);
  }

}

customElements.define('wishlist-custom', WishlistButton);

class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      fetch(this.dataset.url)
        .then(response => response.text())
        .then(text => {
          const html = document.createElement('div');
          html.innerHTML = text;
          const recommendations = html.querySelector('product-recommendations');

          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;
          }

          if (!this.querySelector('slideshow-component') && this.classList.contains('complementary-products')) {
            this.remove();
          }

          if (html.querySelector('.grid__item')) {
            this.classList.add('product-recommendations--loaded');
          }
        })
        .catch(e => {
          console.error(e);
        });
    }

    new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 500px 0px'}).observe(this);
  }
}

customElements.define('product-recommendations', ProductRecommendations);

class StyleWith extends HTMLElement{
  constructor() {
    super();
  }


  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);
      this.querySelector(".intersection-container").classList.remove("hidden");
    }

    new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 0px 0px'}).observe(this);
  }

}

customElements.define('style-with', StyleWith);


class MegaMenu extends HTMLElement {
  constructor() {
      super();
      this.headerWrapper = document.querySelector('.header-wrapper');
      this.mega_menus = this.querySelectorAll(".mega-menu__content");
      this.bindEvents();
      this.createSpacer();
  }

  bindEvents() {
      this.querySelectorAll('.header__menu-item')
          .forEach(menuItem => menuItem.addEventListener('mouseenter', this.onMenuItemEnter.bind(this)));
      this.querySelectorAll('.header__menu-item.has-menu')
          .forEach(menuItem => menuItem.addEventListener('click', (e)=>this.onItemClick(menuItem, e)));
      this.headerWrapper.addEventListener('mouseleave', this.closeSubMenus.bind(this));
  }

  onItemClick(item, e){
    e.preventDefault();
    const newLocation = item.querySelector('a').href;
    window.location.href = newLocation;
  }

  onMenuItemEnter(event) {
      this.closeSubMenus();
      const element = event.target;

      const toOpen = element.closest("details");
      if(toOpen) toOpen.open = true;
      element.setAttribute("aria-expanded", "true");
  }

  closeSubMenus() {
      this.querySelectorAll('details').forEach(menuWrapper => menuWrapper.open = false);
      this.querySelectorAll('summary').forEach(trigger => trigger.setAttribute("aria-expanded", "false"));
  }

  /*Create spacer between menus and images in every mega menu */
  createSpacer(){
    let index = 0;
    let spacer = null;
    this.mega_menus.forEach((mega_menu)=>{
      index = 0;
      if(mega_menu.querySelector(".mega-menu__img") && mega_menu.querySelector(".mega-menu__list")){
        spacer = document.createElement("div");
        spacer.classList.add("spacer");
        mega_menu.querySelectorAll(".mega-menu__list").forEach((list)=>{
          index ++;
        });
        // console.log(mega_menu.querySelectorAll(".mega-menu__list")[index - 1].nextElementSibling);
        mega_menu.querySelector(".mega-menu__content-container").insertBefore(spacer, mega_menu.querySelectorAll(".mega-menu__list")[index - 1].nextSibling);
      }
      else if(mega_menu.querySelector(".mega-menu__img") && mega_menu.querySelector(".mega-menu__list") == null){
        mega_menu.querySelector(".mega-menu__content-container").classList.add("right-content");
      }
    })
  }

}

customElements.define('mega-menu', MegaMenu);

class Accordion extends HTMLElement{
  constructor(){
    super();
    this.mobile = window.matchMedia("(max-width: 767px)").matches;
    // this.trigger = this.querySelector(".collection-hero__description svg");
    // this.description = this.querySelector(".collection-hero__description");
    if(this.trigger && this.description)
      this.listener();

    this.container = this.querySelector('.collection-hero__description p');
    this.toggleButton = this.querySelector('.trigger');
    this.contentElement = this.querySelector('.collection-hero__description p span');

    if(this.toggleButton && this.container && this.mobile ){
      this.longContent = this.contentElement.textContent;
      this.shortContent = `${this.longContent.substring(0, 90)}...`;
      this.listener();
      // this.toggleText();
    }
  }

  connectedCallback(){
    if(this.container){
      if(this.mobile){
        this.contentElement.innerHTML = this.shortContent;
        this.contentElement.appendChild(this.toggleButton);
        this.container.setAttribute('data-content', 'short');
        this.container.style.opacity = 1;
      }
      else{
        this.container.style.opacity = 1;
      }
    }
  }

  listener(){
    this.toggleButton.addEventListener("click", ()=>{
      this.toggleText();
      // if(!this.description.classList.contains("open")){
      //   this.description.classList.add("open");
      // }
      // else{
      //   this.description.classList.remove("open");
      // }
    })
  }

  toggleText() {
    if (this.container.dataset.content == 'long'){
      this.contentElement.innerHTML = this.shortContent;
      this.contentElement.appendChild(this.toggleButton);
      this.container.setAttribute('data-content', 'short');
    } else {
      this.contentElement.innerHTML = this.longContent;
      this.contentElement.appendChild(this.toggleButton);
      this.container.setAttribute('data-content', 'long');
    }
  }

}

customElements.define('custom-accordion', Accordion);

class FollowBrands extends HTMLElement{
  constructor(){
    super();
    this.brands = this.dataset.meta != '' ? this.dataset.meta : [];
  }

  isLogged(){
    return this.dataset.customer !== '';
  }

  showBanner(banner){
    if(!banner.classList.contains('show'))
      banner.classList.add('show');
  }

  closeBanner(banner){
    banner.classList.remove('show');
  }

  followDesigner(target, designer){
    if(typeof this.brands != 'object'){
      this.brands = this.brands.split(",");
    }
    designer = designer.toLowerCase();
    // console.log(this.brands);
    // console.log(designer);
    if(!this.brands.includes(designer)){
      this.brands.push(designer);
    }
    else{
      this.brands.splice(this.brands.indexOf(designer), 1);
    }
    this.handleClick(this.brands);
    console.log(this.brands);
    // console.log(this.brands);
    const valueObj = { value: this.brands.toString() };
    const requestParams = { raven: Object.assign({}, ravenObj, valueObj) };
    // console.log(requestParams);

    const response = fetch('/apps/raven/create_metafield', {
      method : 'PUT',
      headers: { 'Content-Type': 'application/json' },
      body   : JSON.stringify(requestParams)
    })

    response
      .then(res => res.json())
      .then(resJson => console.log('resJson: ', resJson))
      .then(()=>{
        this.feedbackAfterFollow(target);
        // klaviyo.push(['identify', {
        //   'brand' : this.brands.toString()
        // }]);
      })
  }
}

class FollowDesigner extends FollowBrands{
  constructor(){
    super();
    this.bannerLogin = this.querySelector(".banner_login");
    this.is_logged = super.isLogged();
    this.listener();
  }

  listener(){
    this.addEventListener("click", (e)=>{
      if(e.target.matches('.follow-brand, .follow-brand *')){
        if(!this.is_logged){
          super.showBanner(this.bannerLogin);
        }
        else{
          super.followDesigner(e.target, e.target.closest(".designer").querySelector(".designer_link").innerText);
        }
      }
      if(e.target.matches('.banner_login .icon-close, .banner_login .icon-close *')){
        super.closeBanner(this.bannerLogin);
      }
    });
  }

  handleClick(brands){
    this.querySelector(".container_designers").classList.add("no-click");
    let meta_cust = "";
        brands    = JSON.stringify(brands).trim();
    let interval = setInterval(()=>{
      fetch('/?sections=test-metafield-section', {
        method : 'GET',
        headers: { 'Content-Type': 'application/json' }
      }).then(res => res.json())
        .then(resJson =>{
          const parser         = new DOMParser();
          const parsedDocument = parser.parseFromString(resJson["test-metafield-section"], "text/html");
                meta_cust      = parsedDocument.querySelector("pre").innerText;
                meta_cust      = meta_cust.trim();
                meta_cust      = meta_cust.split(',');
                meta_cust      = JSON.stringify(meta_cust);
          if(brands === meta_cust){
            clearInterval(interval);
            this.querySelector(".container_designers").classList.remove("no-click");
          }
        })
        .catch(e => console.log(e.message));
    },200);
    setTimeout(()=>{
      clearInterval(interval);
      this.querySelector(".container_designers").classList.remove("no-click");
    }, 8000);
  }

  feedbackAfterFollow(target){
    if(!target.matches('.icon-blackstar')){
      target = target.closest(".icon-blackstar");
    }
    if(!target.classList.contains("active")){
      target.classList.add("active");
    }
    else{
      target.classList.remove("active");
    }
  }
}

customElements.define('follow-designer', FollowDesigner);

class FollowPlp extends FollowBrands{
  constructor(){
    super();
    this.bannerLogin = this.querySelector(".banner_login");
    this.is_logged = super.isLogged();
    this.designer = this.querySelector(".follow-brand").dataset.brand;
    this.listener();
  }

  listener(){
    this.addEventListener("click", (e)=>{
      if(e.target.matches('.follow-brand, .follow-brand *')){
        if(!this.is_logged){
          super.showBanner(this.bannerLogin);
        }
        else{
          super.followDesigner(e.target, e.target.closest(".follow-brand").dataset.brand);
        }
      }
      if(e.target.matches('.banner_login .icon-close, .banner_login .icon-close *')){
        super.closeBanner(this.bannerLogin);
      }
    });
  }

  feedbackAfterFollow(target){
    let button = this.querySelector(".follow-brand");
    if(target.closest(".follow-brand").classList.contains("unfollow")){
      console.log("unfollow");
      let text = this.dataset.text;
      button.querySelector("span").textContent = text + " " + this.designer;
      button.classList.remove("unfollow");
    }
    else{
      console.log("follow")
      let alt_text = this.dataset.alt;
      button.querySelector("span").textContent = alt_text + " " + this.designer;
      button.classList.add("unfollow");
    }
  }

  handleClick(brands){
    this.querySelector(".button.follow-brand").classList.add("no-click");
    let meta_cust = "";
        brands    = JSON.stringify(brands).trim();
    let interval = setInterval(()=>{
      fetch('/?sections=test-metafield-section', {
        method : 'GET',
        headers: { 'Content-Type': 'application/json' }
      }).then(res => res.json())
        .then(resJson =>{
          const parser         = new DOMParser();
          const parsedDocument = parser.parseFromString(resJson["test-metafield-section"], "text/html");
                meta_cust      = parsedDocument.querySelector("pre").innerText;
                meta_cust      = meta_cust.trim();
                meta_cust      = meta_cust.split(',');
                meta_cust      = JSON.stringify(meta_cust);
          if(brands === meta_cust){
            clearInterval(interval);
            this.querySelector(".button.follow-brand").classList.remove("no-click");
          }
        })
        .catch(e => console.log(e.message));
    },200);
    setTimeout(()=>{
      clearInterval(interval);
      this.querySelector(".button.follow-brand").classList.remove("no-click");
    }, 8000);
  }
}

customElements.define('follow-plp', FollowPlp);

class Designer extends FollowDesigner{
  constructor(){
    super();
    this.groups    = this.querySelectorAll(".designers .container_designers .group")
    this.designers = this.querySelectorAll(".designers .designer");
    this.letters   = this.querySelectorAll(".letter");
    this.stars     = this.querySelectorAll(".designer svg");
    this.is_logged = super.isLogged();
    this.listener();
    this.handleVisibility();
    this.calcMaxHeight(window.screen.width);
  }

  // connectedCallback(){
  //   if(this.is_logged){
  //     this.getLocalBrands();
  //   }
  // }

  // //prendo i brands dall'oggetto locale di klavyio per avere un feedback immediato del follow brand (il metafield richiede tempo per essere scritto)
  // getLocalBrands(){
  //   klaviyo.identify().then(customer_info =>{
  //     let designers = this.designers;
  //     let brands    = customer_info.brand;
  //     if(typeof brands != 'undefined'){
  //       brands = brands.split(",");
  //       brands = brands.map(brand => brand.toLowerCase());
  //       designers.forEach(designer =>{
  //         if(brands.includes(designer.querySelector(".designer_link").innerText.toLowerCase())){
  //           if(!designer.querySelector(".icon-blackstar").classList.contains("active"))
  //             designer.querySelector(".icon-blackstar").classList.add("active");
  //         }
  //         else{
  //           if(designer.querySelector(".icon-blackstar").classList.contains("active"))
  //             designer.querySelector(".icon-blackstar").classList.remove("active");
  //         }
  //       })
  //     }
  //   })
  //   .catch(error => {console.error(error.message)})
  // }

  listener(){
    this.addEventListener("click", (e)=>{
      // if(e.target.matches('.banner_login .icon-close, .banner_login .icon-close *')){
      //   this.closeBanner();
      // }
      if(e.target.matches('.letter')){
        this.letterFilter(e.target);
      }
      if(!e.target.matches('.letter, .designer svg, .designer svg *')){
        this.clearFilter();
      }
      this.querySelectorAll('a[href^="#"]').forEach(anchor => {
        if(e.target == anchor){
          e.preventDefault();
          this.smoothScroll(anchor);
        }
      });
      // if(e.target.matches('.designer svg, .designer svg *')){
      //   if(!this.is_logged){
      //     this.showBanner();
      //   }
      //   else{
      //     this.changeIcon(e.target);
      //     this.followDesigner(e.target);
      //   }
      // }
    });
    window.addEventListener("resize", ()=>{
      this.calcMaxHeight(window.screen.width);
    })
  }

  calcMaxHeight(screen_width){
    if(this.designers.length > 10){
      if(screen_width >=768){
        let n_designers = this.designers.length;
        //media altezza singolo elemento (per schermo 1024 in cui alcuni elementi vanno a capo e diventano più alti)
        let tot_height = 0;
        this.designers.forEach(designer => tot_height += designer.clientHeight);
        const mid_height = tot_height / n_designers;
        //num elementi in una colonna (4 colonne)
        let designers_per_column = n_designers / 4;
        let n_groups = 0;
        let height_group = 0;
        this.groups.forEach(group =>{
          if(group.classList.contains("visible")){
            n_groups++;
          }
          height_group = height_group + group.clientHeight;
        });
        let groups_per_column = n_groups / 4;
        if(screen_width >= 768 && screen_width < 1024){
          designers_per_column = n_designers / 2;
          groups_per_column = n_groups / 2;
        }
        // console.log(height_group);
        // console.log("n designers: ", n_designers);
        // console.log("n_groups", n_groups);
        // console.log("groups_per_column:", groups_per_column);
        // console.log("designers per column:", designers_per_column);

        //(altezza di un elemento * num elem in una colonna + spazio tra i gruppi + spazio tra ogni gruppo della colonna e la lettera + spazio tra gli elementi) + costante che cambia in base al numero di colonne necessarie trovata un po' a caso
        let max_height = (24 * designers_per_column + groups_per_column * 20 + designers_per_column * 8) + 150;
        if(screen_width >= 1024 && screen_width < 1280){
          max_height = (mid_height * designers_per_column + groups_per_column * 20 + designers_per_column * 8) + 150;
        }
        if(screen_width >= 768 && screen_width < 1024){
          max_height = (24 * designers_per_column + groups_per_column * 20 + designers_per_column * 8) + 150;
        }
        // console.log(max_height);
        this.querySelector(".container_designers").style.maxHeight = max_height + "px";
      }
      else{
        this.querySelector(".container_designers").style.maxHeight = 'none';
      }
    }

  }

  smoothScroll(anchor){
    this.querySelector(anchor.getAttribute('href')).scrollIntoView({
      behavior: 'smooth'
    });
  }

  //visualizza i gruppi delle lettere con designers
  handleVisibility(){
    this.groups.forEach((group)=>{
      if(group.querySelector(".designers_group").children.length > 0){
        group.classList.add("visible");
      }
      else{
        this.letters.forEach((filter_letter)=>{
          if(filter_letter.innerText == group.id){
            filter_letter.classList.add("disable");
          }
        })
      }
    })
  }

  letterFilter(active_letter){
    //show only letter clicked
    this.letters.forEach(letter =>{
      if(letter != active_letter){
        if(!letter.classList.contains("opacity"))
          letter.classList.add("opacity");
      }
      else{
        letter.classList.remove("opacity");
      }
    })
    //show only letter group
    this.designers.forEach(designer =>{
      if(designer.querySelector(".designer_link").dataset.letter != active_letter.innerText){
        if(!designer.classList.contains("disable"))
          designer.classList.add("disable");
      }
      else{
        designer.classList.remove("disable")
      }
    })
  }

  clearFilter(){
    this.letters.forEach(letter =>{
      letter.classList.remove("opacity");
    })
    this.designers.forEach(designer =>{
      designer.classList.remove("disable");
    })
  }
}

customElements.define('designers-element', Designer);

class NewIn extends HTMLElement{
  constructor(){
    super();
    this.publish = this.dataset.publish;
    this.currentDate = this.dataset.current;
    this.label = this.querySelector("label");
    this.n_days = this.dataset.days;
    this.handleLabel();
  }

  handleLabel(){
    let publish_date = new Date(this.publish);
    let actual_date = new Date(this.currentDate);

    let difference = Math.abs(actual_date - publish_date);
    let days_difference = Math.ceil(difference / (1000 * 3600 * 24));

    if(days_difference > this.n_days){
      this.label.style.display = "none";
    }
  }
}

customElements.define('new-in', NewIn);
// class FindInStore extends HTMLElement{
//   constructor(){
//     super();
//     console.log(this.querySelector('[type="application/json"]'));
//     this.data_metafield = JSON.parse(this.querySelector('[type="application/json"]').textContent);
//     this.data_variants = document.querySelector("variant-selects [type='application/json']") ? JSON.parse(document.querySelector("variant-selects [type='application/json']").textContent) : false;
//     this.variant_select = document.querySelector(".size_map select") ? document.querySelector(".size_map select") : false;
//     this.shopsContainer = document.querySelector('.product__shops-availability') ? document.querySelector('.product__shops-availability') : false;
//     this.value = this.getValue();
//     this.readEvent();
//   }

//   getValue(){
//     if(this.variant_select){
//       return this.variant_select.value
//     }
//   }

//   readEvent(){
//     console.log(this.value);
//     document.addEventListener("changeVariant", ()=>{
//       if (this.shopsContainer) {
//         this.updateMasterId();
//         this.getShopsAvailability();
//       }
//     })
//   }

//   updateMasterId() {
//     this.currentVariant = this.data_variants.find((variant) => {
//         return !variant.options.map((option, index) => {
//             return this.options[index] === option;
//         }).includes(false);
//     });
//   }

//   getShopsAvailability() {
//     if (this.value) {
//         this.currentVariantSelected = this.data_metafield.find((variant) => {
//             return this.currentVariant.id === variant.id;
//         });

//         this.renderShopsAvailabilityInfo();
//     }
//   }

//   renderShopsAvailabilityInfo() {
//     const self = this;
//     this.shopsAvailable = 0;
//     this.shopsContainer.querySelectorAll('.list-shops li').forEach(function (item, index) {
//         if (!self.currentVariantSelected.shops.includes(item.dataset.id)) {
//             item.classList.add('hidden');
//             // item.querySelector('span').innerText = window.variantStrings.unavailable
//         } else {
//             self.shopsAvailable++;
//             item.classList.remove('hidden');
//             item.querySelector('span').innerText = window.variantStrings.available
//         }
//     });
//     if(self.shopsAvailable == 0) {
//         const shopsList = this.shopsContainer.querySelector('.list-shops');
//         const listItem = document.createElement('li');
//         listItem.innerHTML = window.variantStrings.shops_unavailable;
//         shopsList.appendChild(listItem);
//     }
//     // this.toggleAvailability();
//   }


// }

// customElements.define('find-in-store', FindInStore);


class MobileDrawer{
  constructor(){
    this.header = document.querySelector(".header");
    this.listener();
  }

  listener(){
    document.addEventListener("click", (e)=>{
      if(e.target.matches(".header__icon--menu, .header__icon--menu *")){
        // this.mutationObserverAttribute(this.header.querySelector("#Details-menu-drawer-container"));
        this.hideIcons(this.header);
      }
      if(e.target.matches("summary.menu-drawer__menu-item")){
        this.showIconBack(this.header);
      }
      if(e.target.matches(".menu-drawer__close-button")){
        if(!this.header.querySelector(".menu-drawer__menu").classList.contains("submenu-open")){
          this.hideIconBack(this.header);
        }
      }
      if(e.target.matches(".header__icon--back, .header__icon--back *")){
        this.triggerBackMenu(this.header);
      }
    })
  }

  mutationObserverAttribute(node){
    // Select the node that will be observed for mutations
    const targetNode = node;

    // Options for the observer (which mutations to observe)
    const config = { attributes: true};

    // Callback function to execute when mutations are observed
    const callback = (mutationList, observer) => {
      for (const mutation of mutationList) {
        if (mutation.type === 'attributes') {
          this.hideIcons(this.header);
          observer.disconnect();
        }
      }
    };

    // Create an observer instance linked to the callback function
    const observer = new MutationObserver(callback);

    // Start observing the target node for configured mutations
    observer.observe(targetNode, config);
  }

  /* hide/show icons when drawer menu is open/close */
  hideIcons(header){
    if(!header.querySelector("#Details-menu-drawer-container").open){
      header.querySelector(".header__icon--search").style.display = "none";
      header.querySelector(".header__icon--cart").style.display = "none";

    }
    else{
      header.querySelector(".header__icon--search").style.display = "inline-block";
      header.querySelector(".header__icon--cart").style.display = "flex";
      header.querySelector(".header__icon--back").style.display = "none";
    }
  }

  showIconBack(header){
    header.querySelector(".header__icon--back").style.display = "flex";
  }

  hideIconBack(header){
    header.querySelector(".header__icon--back").style.display = "none";
  }

  triggerBackMenu(header){
    let menusOpen = header.querySelectorAll("details.menu-opening");
    let lastMenuOpen = null;

    menusOpen.forEach((menuOpen) =>{
      lastMenuOpen = menuOpen;
    });

    let button = lastMenuOpen.querySelector(".menu-drawer__close-button");
    if(button){
      button.click();
    }
  }
}

const mobileDrawer = new MobileDrawer();


class Countdown extends HTMLElement{
  constructor(){
    super();
    this.start_countdown = this.dataset.start_countdown;
    this.end_countdown = this.dataset.end_countdown;
  }

  //start when render element
  connectedCallback(){
    let actualDate = this.getUTCDate();
    let start = this.startCount(actualDate);
    if(start){
      this.countdown(actualDate);
    }
    else{
      this.restorePdp();
      this.restorePlp();
    }
  }

  getUTCDate(){
    let actualDate = new Date();
    actualDate = actualDate.toISOString();
    actualDate = new Date(actualDate.split('.')[0]).getTime();
    return actualDate;
  }

  // getTimeZone(){
  //   const myPromise = new Promise((resolve, reject) => {
  //     fetch('/admin/shop.json')
  //     .then(res => res.json())
  //       .then(data => {
  //         resolve(data.shop.timezone)
  //       });
  //   });
  //   return myPromise;
  // }

  //find if count down has to start
  startCount(actualDate){
    let startDate = new Date(this.start_countdown).getTime();
    let distance = startDate - actualDate
    if(distance < 0){
      return true;
    }
    else{
      return false;
    }
  }

  countdown(actualDate){
    let self = this;
    // Set the date we're counting down to
    let countDownDate = new Date(this.end_countdown).getTime();
    // Update the count down every 1 second
    let x = setInterval(function() {

      // Get start date and time
      let start = self.getUTCDate();
      // Find the distance between now and the count down date
      let distance = countDownDate - start;

      // Time calculations for days, hours, minutes and seconds
      let days = Math.floor(distance / (1000 * 60 * 60 * 24));
      let hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      let minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      let seconds = Math.floor((distance % (1000 * 60)) / 1000);

      // Output the result
      self.buildCountdown(days,hours,minutes,seconds);

      // If the count down is over restore elements
      if (distance < 0) {
        clearInterval(x);
        !self.classList.contains("hidden") ? self.classList.add("hidden") : null;
        self.restorePdp();
        self.restorePlp();
      }
      else{
        self.classList.contains("hidden") ? self.classList.remove("hidden") : null;
      }
    }, 1000);
  }

  //vietti builder count down
  buildCountdown(days,hours,minutes,seconds){
    this.querySelector("#countdown .days > p").innerHTML = days;
    this.querySelector("#countdown .hours > p").innerHTML = hours;
    this.querySelector("#countdown .minutes > p").innerHTML = minutes;
    this.querySelector("#countdown .seconds > p").innerHTML = seconds;
  }

  //vietti restore pdp
  restorePdp(){
    document.querySelector("variant-selects")?.classList.contains("hidden") ? document.querySelector("variant-selects").classList.remove("hidden") : null;
    document.querySelector(".form-container")?.classList.contains("hidden") ? document.querySelector(".form-container").classList.remove("hidden") : null;
    document.querySelector(".info-container")?.classList.contains("hidden") ? document.querySelector(".info-container").classList.remove("hidden") : null;
  }

  //vietti restore plp
  restorePlp(){
    this.closest(".card")?.querySelector(".card__inner")?.classList.contains("countdown") ? this.closest(".card").querySelector(".card__inner").classList.remove("countdown") : null;
    this.closest(".card__media")?.querySelector(".media")?.classList.contains("countdown") ? this.closest(".card__media").querySelector(".media").classList.remove("countdown") : null;
  }
}

customElements.define("my-countdown", Countdown);